const priceRegex = /^((0|[1-9]+[\d]*)(?:[.,][\d]{0,2})?)?$/;
export const normalizePrice = (value, previousValue, { min, max } = {}) => {
    value = value.match(priceRegex) ? value.replace(',', '.') : previousValue;
    if (max) {
        value = Number(value) > max ? max.toString() : value;
    }
    if (min) {
        value = Number(value) < min ? min.toString() : value;
    }
    return value;
};
export const isPriceValid = (price, maxPrice) => {
    const regex = /^((0|[1-9]+[\d]*)(\.[\d]{1,2})?)?$/;
    return !!price && !!price.toString().match(regex) && (!maxPrice || Number(price) <= maxPrice);
};
//# sourceMappingURL=validator.js.map